import calculateInternationalSizing from './calculateInternationalSizing';
import determineSize from './determineSize';

const switcherSizing = ():void => {

  const getSize = determineSize();

  const usSwitcher = document.querySelectorAll('[data-size-switcher="us"]');
  const euSwitcher = document.querySelectorAll('[data-size-switcher="eu"]');
  const ukSwitcher = document.querySelectorAll('[data-size-switcher="uk"]');

  const sizeSwitchers = document.querySelectorAll('[data-size-switcher]');

  const sizeGuideSwitchers = document.querySelectorAll('[data-country-size-conversion]') as NodeListOf<HTMLSelectElement>;

  sizeGuideSwitchers.forEach((sizeGuideSwitcher) => {
    sizeGuideSwitcher.addEventListener('change', function() {
      const sizeGuideSwitcherElem = document.querySelector(`[data-size-switcher="${sizeGuideSwitcher.value}"]`) as HTMLElement;
      sizeGuideSwitcherElem.click();
    });
  });

  sizeSwitchers.forEach((switcher: HTMLElement) => {
    switcher?.addEventListener('click', (e) => {

      const fromSizeElem = document.querySelector('[data-size-switcher].active') as HTMLElement;
      const fromSizeElems = document.querySelectorAll(`[data-size-switcher="${fromSizeElem.dataset.sizeSwitcher}"]`);

      const fromSizeValue = fromSizeElem.innerHTML.toLowerCase();

      const toSizeElem = e.target as HTMLElement;
      const toSizeElems = document.querySelectorAll(`[data-size-switcher="${toSizeElem.dataset.sizeSwitcher}"]`);

      fromSizeElems.forEach(fromSize => fromSize.classList.remove('active'));

      toSizeElems.forEach(toSize => toSize.classList.add('active'));

      const toSizeValue = toSizeElem.innerHTML.toLowerCase();

      localStorage.sizeOverride = toSizeValue;

      sizeGuideSwitchers.forEach((sizeGuideSwitcher) => {
        sizeGuideSwitcher.value = toSizeValue;
      });

      calculateInternationalSizing('all', toSizeValue, fromSizeValue);
    });
  })

  if(getSize === 'US') usSwitcher?.forEach(switcher => switcher.classList.add('active'));
  if(getSize === 'EU') euSwitcher?.forEach(switcher => switcher.classList.add('active'));
  if(getSize === 'UK') ukSwitcher?.forEach(switcher => switcher.classList.add('active'));

  sizeGuideSwitchers.forEach((sizeGuideSwitcher) => {
    sizeGuideSwitcher.value = getSize.toLowerCase();
  });

}

export default switcherSizing